/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AutogenerateInputs */

const en_autogenerate = /** @type {(inputs: AutogenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-generate`)
};

const es_autogenerate = /** @type {(inputs: AutogenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autogenerar`)
};

const fr_autogenerate = /** @type {(inputs: AutogenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autogénérer`)
};

const de_autogenerate = /** @type {(inputs: AutogenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisch generieren`)
};

const ja_autogenerate = /** @type {(inputs: AutogenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動生成する`)
};

const zh_autogenerate = /** @type {(inputs: AutogenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动生成`)
};

const ar_autogenerate = /** @type {(inputs: AutogenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنشاء تلقائي`)
};

const id_autogenerate = /** @type {(inputs: AutogenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat Otomatis`)
};

const it_autogenerate = /** @type {(inputs: AutogenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera Automaticamente`)
};

const ru_autogenerate = /** @type {(inputs: AutogenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сгенерировать`)
};

const pt_autogenerate = /** @type {(inputs: AutogenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerar automaticamente`)
};

const ko_autogenerate = /** @type {(inputs: AutogenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자동 생성`)
};

/**
* | output |
* | --- |
* | "Auto-generate" |
*
* @param {AutogenerateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const autogenerate = /** @type {((inputs?: AutogenerateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AutogenerateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_autogenerate(inputs)
	if (locale === "es") return es_autogenerate(inputs)
	if (locale === "fr") return fr_autogenerate(inputs)
	if (locale === "de") return de_autogenerate(inputs)
	if (locale === "ja") return ja_autogenerate(inputs)
	if (locale === "zh") return zh_autogenerate(inputs)
	if (locale === "ar") return ar_autogenerate(inputs)
	if (locale === "id") return id_autogenerate(inputs)
	if (locale === "it") return it_autogenerate(inputs)
	if (locale === "ru") return ru_autogenerate(inputs)
	if (locale === "pt") return pt_autogenerate(inputs)
	return ko_autogenerate(inputs)
});